






















































	import { Vue, Component, Prop ,Watch} from "../../Infrastructure/CorBase/CoreBase";

	@Component
	export default class BaseTLFilterValueItem extends Vue {
		@Prop({ type: String, required: false, default: "" }) design?: string; //typ designu co se zobrazi typy: GridMedia, GridReceiver	
		@Prop({ type: Boolean, required: false, default: false }) isGroup?: boolean; //jestli se jedná o skupinový filtr

		//filtr jednotlivý
		@Prop({ type: String, required: false, default: "" }) name?: string; //pro koho je to popisek
		@Prop({ type: String, required: false, default: "" }) label?: string; //nazev filtru
		@Prop({ type: String, required: false, default: "popis" }) tooltip?: string; //tooltip		
		@Prop({ type: String, required: false, default: "" }) id?: string; //key
		@Prop({ required: false }) item: any; // konkretni filtr
		@Prop({ type: Boolean, required: false, default: false }) isMulti?: boolean; //je to multi filtr
		@Prop({ required: false }) itemsMulti: any; //všechny multi filtry
		//filtr skupinový
		@Prop({ required: false }) itemsGroup: any; //všechny filtry
		@Prop({ type: Boolean, required: false, default: false }) isNegative?: boolean; //zobrazi se když není vybrán

		getStyleColorTags(item: any) {
			var border = item.isOR == true ? "border: 2px solid black;padding-top:0px;" : "";
			return 'background-color:' + item.color + ';' + border;
		}



        mounted() {

            setTimeout(() => {
                this.$nextTick(() => {
                    const input = this.$refs.editableInputFilter as HTMLInputElement;
                    if (input) {
                        input.focus();
                    }
                });
            }, 500); // Delay of 5 seconds
        }
		
		inputChange() {
            this.$emit('change', this.item);
		}

		isEditableFilter() {
			return this.item.isEditable == undefined ? false : this.item.isEditable === true;
		}

		isPersistFilter(item: any): boolean {		
			if (item != undefined ) {
				return item.default != undefined;
			}
			else {
				return true;
			}
		}

		showFilter(item: any): boolean {
			if (item != undefined && item.multiselect != true) {
				return item.default != item.value && item.showAnyTime != true;
			}
			else {
				return true;
			}
		}

		remove() {
			this.$emit('removeFilter', this.id);
		}

		removeMulti(item: any) {
            this.$emit('removeMultiFilter', item, this.item);
        }

		removeItem(key: string) {
			if (this.isNegative) {
				this.$emit('removeGroupNegativeFilter', key);
			}
			else {
				this.$emit('removeGroupFilter', key);
			}
		}

	}
